import React, { FC } from "react";
import {
  Container,
  Main,
  DataPrivacyDiv,
  TextWrapper,
  HeaderWrapper,
  HeaderText,
  ButtonWrapper,
  ImageWrapper,
  Logo,
  ModalHyperlink,
} from "./elements";
import { Button } from "../../atoms/Button";
import { Modal } from "../../organisms/Modal";
import logo from "../../../assets/images/new_logo_dark.svg";
type Props = {
  onClickHere: () => void;
  onAgree: () => void;
  modalVisible: boolean;
  onModalClose: () => void;
  modalTitle: string;
  modalBody: JSX.Element;
  modalHeight: string;
};

const DataPrivacy: FC<Props> = (props) => {
  const {
    onClickHere,
    onAgree,
    modalVisible,
    onModalClose,
    modalTitle,
    modalBody,
    modalHeight,
  } = props;

  return (
    <Main>
      <Container>
        <ImageWrapper>
          <Logo src={logo} alt="logo" />
        </ImageWrapper>
        <DataPrivacyDiv>
          <HeaderWrapper>
            <HeaderText>We value your privacy</HeaderText>
          </HeaderWrapper>
          <TextWrapper>
            <p>
              Through this platform, the following personal information will be
              collected but not limited to: full name, address, contact number,
              email address and resume. These personal information will be used
              solely to enable us to contact you and process your application in
              Everbank Vananaz, Inc. It will be used within VSI and will not be
              shared with any outside parties. We value your rights as data
              subjects under the Data Privacy Act.
            </p>
            <p>
              Please click "I Agree" to accept this use of your data. <br /> For
              more information on how we process your personal data, please
              refer <ModalHyperlink onClick={onClickHere}>here</ModalHyperlink>.
            </p>
          </TextWrapper>
          <ButtonWrapper>
            <Button type="primary" onClick={onAgree}>
              I Agree
            </Button>
            <Modal
              visible={modalVisible}
              onModalClose={onModalClose}
              title={modalTitle}
              body={modalBody}
              height={modalHeight}
              width={"54%"}
            />
          </ButtonWrapper>
        </DataPrivacyDiv>
      </Container>
    </Main>
  );
};

export default DataPrivacy;
